import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import {
  AD_SLOTS,
  AD_SYSTEM,
  AD_SYSTEM_LABEL,
  slotNoText,
} from "helpers/adSlots";

/**
 * "Reklam Alanları Rehberi" — numaralı alan listesi.
 *
 * Panelde reklam eklerken en cok sorulan sey "bu reklam uygulamada nereye
 * dusecek". Alanlarin numarasini, hangi ekranlarda gorundugunu ve hangi panel
 * sayfasindan yonetildigini tek tabloda gosterir.
 *
 * Ucu sayfada da (Reklam Alanlari / Talepler, Reklam Kategorisi, Liste Arasi
 * Reklamlar) ayni bilesen kullanilir ki numaralandirma tek yerden gelsin.
 */
const AdSlotGuide = ({ highlightSystem, buttonClassName }) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);

  return (
    <React.Fragment>
      <button
        type="button"
        className={buttonClassName || "btn btn-outline-info btn-sm"}
        onClick={toggle}
      >
        <i className="bx bx-map-alt align-middle me-1" />
        Reklam Alanları Rehberi (Alan No)
      </button>

      <Modal isOpen={open} toggle={toggle} size="lg" scrollable>
        <ModalHeader toggle={toggle} tag="h4">
          Reklam Alanları Rehberi
        </ModalHeader>
        <ModalBody>
          <p className="text-muted font-size-13">
            Uygulamadaki her reklam alanının sabit bir <strong>Alan No</strong>’su
            vardır. Müşteriye “reklamınız <strong>3 numaralı alanda</strong>
            yayında” diyebilir, panelde de aynı numaralı kategoriyi seçersiniz.
            Numaralar uygulamada yukarıdan aşağıya gezme sırasına göre verilmiştir
            ve değişmez.
          </p>

          <div className="table-responsive">
            <Table className="table-sm align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th style={{ width: 70 }}>Alan No</th>
                  <th>Panelde seçilecek kategori</th>
                  <th>Uygulamada nerede görünür</th>
                  <th style={{ width: 190 }}>Gösterim</th>
                </tr>
              </thead>
              <tbody>
                {AD_SLOTS.map(slot => {
                  const dim = highlightSystem && slot.system !== highlightSystem;
                  return (
                    <tr key={slot.no} className={dim ? "text-muted" : ""}>
                      <td>
                        <span
                          className={
                            "badge font-size-12 " +
                            (slot.status === "off"
                              ? "badge-soft-secondary"
                              : "badge-soft-primary")
                          }
                        >
                          {slotNoText(slot.no)}
                        </span>
                      </td>
                      <td>
                        <div className="fw-medium">{slot.title}</div>
                        <div className="font-size-11 text-muted">
                          {AD_SYSTEM_LABEL[slot.system]} sayfası
                        </div>
                      </td>
                      <td>
                        {slot.status === "off" ? (
                          <span className="badge badge-soft-danger font-size-11">
                            Kullanılmıyor
                          </span>
                        ) : (
                          <div>{slot.where}</div>
                        )}
                        {slot.screens && slot.screens.length > 1 ? (
                          <div className="font-size-11 text-muted mt-1">
                            Ayrıca: {slot.screens.slice(1).join(", ")}
                          </div>
                        ) : null}
                        {slot.note ? (
                          <div className="font-size-11 text-danger mt-1">
                            {slot.note}
                          </div>
                        ) : null}
                      </td>
                      <td className="font-size-12">{slot.format}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>

          {/* Ayrintili anlatim (hangi alan hangi ekranda, musteriden ne
              istenecegi, gorsel olculeri) public/reklam-alan-haritasi.html
              icinde duruyor; modal icinde tekrarlamak yerine baglaniyor. */}
          <div className="mt-3">
            <a
              className="btn btn-sm btn-outline-primary"
              href="/reklam-alan-haritasi.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bx bx-link-external align-middle me-1" />
              Ayrıntılı reklam alan haritası
            </a>
          </div>

          <div className="alert alert-info mt-3 mb-0 font-size-12">
            <strong>Not:</strong> Bir alanın numarası, panelde o kategorinin{" "}
            <em>adına</em> bağlıdır. Kategori adı değiştirilirse uygulama o alanı
            bulamaz ve alan boşalır. Ad değiştirmek gerekiyorsa yazılım tarafına
            haber verilmelidir.
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

AdSlotGuide.propTypes = {
  highlightSystem: PropTypes.oneOf([AD_SYSTEM.FORM, AD_SYSTEM.ADVERT]),
  buttonClassName: PropTypes.string,
};

export default AdSlotGuide;
